module.exports = __webpack_public_path__ + "static/media/table-primary.03662b5f.jpg";